// context/ThemeContext.js
import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
  const [colorTheme, setColorTheme] = useState(localStorage.getItem('colorTheme') || 'default');
  const [userColorTheme, setUserColorTheme] = useState(localStorage.getItem('colorTheme') || 'default'); // User's personal theme
  const [useIdeaTheme, setUseIdeaTheme] = useState(localStorage.getItem('useIdeaTheme') === 'true');
  const [currentIdeaTheme, setCurrentIdeaTheme] = useState(null); // Current idea's custom theme

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    localStorage.setItem('theme', theme);
  }, [theme]);

  useEffect(() => {
    // Determine which theme to apply
    const effectiveTheme = (useIdeaTheme && currentIdeaTheme) ? currentIdeaTheme : userColorTheme;
    setColorTheme(effectiveTheme);
    localStorage.setItem('colorTheme', effectiveTheme);
    // Apply color theme classes
    document.documentElement.className = `${effectiveTheme} ${theme}`;
  }, [userColorTheme, currentIdeaTheme, useIdeaTheme, theme]);

  useEffect(() => {
    localStorage.setItem('useIdeaTheme', useIdeaTheme);
  }, [useIdeaTheme]);

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  const changeColorTheme = (newColorTheme) => {
    setUserColorTheme(newColorTheme);
    localStorage.setItem('colorTheme', newColorTheme);
  };

  const toggleUseIdeaTheme = () => {
    setUseIdeaTheme(!useIdeaTheme);
  };

  const setIdeaTheme = (ideaTheme) => {
    setCurrentIdeaTheme(ideaTheme);
  };

  return (
    <ThemeContext.Provider value={{ 
      theme, 
      colorTheme, 
      userColorTheme,
      useIdeaTheme,
      currentIdeaTheme,
      toggleTheme, 
      changeColorTheme,
      toggleUseIdeaTheme,
      setIdeaTheme
    }}>
      {children}
    </ThemeContext.Provider>
  );
};